import { Avatar, Flex, Tooltip, Typography } from "antd"
import classname from "classnames"
import { useTranslation } from "react-i18next"

import Images from "../../Images"
import { paymentProcessorMap } from "../../Utils/utils"

import "./styles.less"

const { Text } = Typography

export const SupportedPlatforms = ({ list, variant = "outlined", ...props }) => {
  const { t } = useTranslation()
  return (
    <Flex
      gap={8}
      align="center"
      className={classname("supported-platforms", `supported-platforms-${variant}`)}
      {...props}
    >
      <Text strong type={variant === "outlined" ? "default" : "secondary"}>
        {t("Supported platforms")}:
      </Text>

      {list ? (
        <Avatar.Group size="small">
          {list?.map((el) => (
            <Tooltip title={paymentProcessorMap[el] || el} key={el}>
              <Avatar
                src={Images[`integration_${el}`]}
                style={{ borderRadius: 4, marginInlineStart: 4 }}
              />
            </Tooltip>
          ))}
        </Avatar.Group>
      ) : (
        <Text type="secondary">-</Text>
      )}
    </Flex>
  )
}
